import styled from 'styled-components';
import Tippy from '@tippyjs/react';
export const StyledTippy = styled(Tippy) `
  border: initial !important;

  .tippy-content {
    background-color: #fff;
    border: 1px solid #c1c1c1;
    box-shadow: 0 20px 20px rgba(0, 0, 0, 0.16);
    padding: 0;
    border-radius: 5px;
  }
`;
//# sourceMappingURL=styles.js.map